/**
 * Custom Hook for Apple Login
 * Handles Apple OAuth popup and Redux integration
 */

import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { loginWithApple } from "../services/appleAuth";
import { socialLogin } from "../redux/slices/authSlice";

export const useAppleLogin = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAppleLogin = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      // Open Apple login popup and get user data
      const appleUserData = await loginWithApple();

      // Prepare data for backend API
      const socialLoginData = {
        provider: "apple",
        identityToken: appleUserData.identityToken, // JWT token for backend verification
        provider_id: appleUserData.provider_id,
        name: appleUserData.name || null, // Only send name if Apple provides it (usually only on first sign-in)
        email: appleUserData.email,
        authorization_code: appleUserData.authorizationCode, // exchanged server-side for a refresh_token
        device_type: "web",
        // username: appleUserData.email,
      };

      console.log("Sending to backend:", socialLoginData);

      // Dispatch Redux action
      const result = await dispatch(socialLogin(socialLoginData)).unwrap();

      console.log("Apple social login result:", result);

      setIsLoading(false);
      return result;
    } catch (err) {
      console.error("Apple login error:", err);
      setError(err.message || "Apple login failed");
      setIsLoading(false);
      throw err;
    }
  }, [dispatch]);

  return {
    handleAppleLogin,
    isLoading,
    error,
  };
};

export default useAppleLogin;
